const isBrowser = () => typeof (window as any).cordova === 'undefined'

export default isBrowser
